/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


export const prepareApiRequestMethod = (method: "POST" | "DELETE" | "PUT" = "POST"): string => {

    return method;

};


export default prepareApiRequestMethod;
